/// <reference types="vite/types/importMeta.d.ts" />

export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;

export const DATE_FORMAT = 'MMM dd, yyyy';
export const DATE_FORMAT_WITH_TIME = 'MMM dd, yyyy, HH:mm';

export const CAREER_LEVELS = [
  { label: 'Entry Level', value: 'Entry Level' },
  { label: 'Mid Level', value: 'Mid Level' },
  { label: 'Senior Level', value: 'Senior Level' },
  { label: 'Executive', value: 'Executive' },
];

export const TIME_FRAMES = [
  { label: '3 Months', value: '3 Months' },
  { label: '6 Months', value: '6 Months' },
  { label: '1 Year', value: '1 Year' },
  { label: '2 Years', value: '2 Years' },
  { label: '3 Years', value: '3 Years' },
  { label: '5 Years', value: '5 Years' },
];
